var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRenault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.31 24H9.719c-.604 0-.828-.201-1.032-.571l-.306-.543a.5.5 0 010-.491l5.867-10.422-2.622-4.647a.5.5 0 010-.491l3.199-5.69a.5.5 0 01.872-.001l5.586 9.908c.32.568.288 1.33-.083 1.988l-5.831 10.347c-.253.447-.539.613-1.059.613zm-4.92-1.361l.171.303a.975.975 0 00.031.058c.017-.004.06 0 .127 0h4.591a.645.645 0 00.134-.009c-.001-.005.019-.033.054-.095l5.831-10.347c.194-.344.228-.749.083-1.006l-5.149-9.135-2.627 4.672 2.622 4.647a.5.5 0 010 .491L9.39 22.639z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.816 23.14a.5.5 0 01-.436-.254l-5.694-10.1c-.313-.558-.188-1.289.062-1.733L8.602.671C8.853.226 9.233 0 9.733 0h4.563c.501 0 .882.226 1.133.671l.267.473a.5.5 0 010 .491L9.861 11.974l2.629 4.662a.5.5 0 010 .491l-3.238 5.758a.5.5 0 01-.436.255zM9.733 1c-.13 0-.181.021-.26.162L3.62 11.543c-.131.233-.16.578-.062.751l5.258 9.326 2.665-4.739-2.629-4.663a.499.499 0 01.001-.492L14.687 1.39l-.128-.228c-.08-.141-.13-.162-.262-.162H9.733z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenault);
export default __webpack_public_path__ + "static/media/renault.a4dc1f0f1bd8f85effae1a3812d3d721.svg";
export { ForwardRef as ReactComponent };